import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { site } from "../data/content";

export default function Blog() {
  return (
    <div className="pt-28 pb-24 min-h-[60vh]">
      <section className="max-w-4xl mx-auto px-6 md:px-12" data-testid="blog-coming-soon">
        <div className="overline">Journal</div>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-4 leading-[1.02]" style={{ color: "var(--primary)" }}>
          Blog <span style={{ color: "var(--accent)", fontStyle: "italic" }}>— coming soon.</span>
        </h1>
        <p className="mt-8 text-lg leading-relaxed" style={{ color: "var(--text-secondary)" }}>
          I'm preparing a series of longform essays on industrial decarbonization, hybrid renewable design, energy markets, and the commercial realities of moving heavy industry to net-zero. Subscribe by dropping me a note — I'll send the first piece directly.
        </p>
        <a
          href={`mailto:${site.email}?subject=Notify%20me%20when%20the%20Journal%20launches`}
          data-testid="blog-notify-cta"
          className="mt-10 inline-flex items-center gap-2 px-6 py-3 text-sm"
          style={{ backgroundColor: "var(--primary)", color: "var(--bg)" }}
        >
          Notify me <Mail size={14} />
        </a>
        <div className="mt-12">
          <Link to="/" className="text-sm link-underline" style={{ color: "var(--primary)" }}>← Back home</Link>
        </div>
      </section>
    </div>
  );
}
